<template>
    <section>
        <ui-button :design="design" :disabled="disabled" :loading="loading" @click="createAdvance">
            {{ nameButton }}
        </ui-button>
    </section>
</template>

<script>
    import { uiButton } from '@/components/ui/buttons'

    import * as axios from '@/services/axios'
    import { mapActions, mapGetters } from 'vuex'

    import { utilMixin } from '@/mixins'

	export default {
        name: 'ui-launch-create-engine',

        components: { uiButton },

        mixins: [utilMixin],

        props: {
            nameButton: {
                type: String,
                required: false,
                default: 'Adicionar'
            },
            data: {
                type: [Array, Object],
                required: false,
                default() {
                    return {}
                }
            },
            disabled: {
                type: Boolean,
                default: false
            },
            service: {
                type: String,
                required: false,
                default: ''
            },
            method: {
                type: String,
                required: false,
                default: ''
            },
            next: {
                type: Object,
                required: false,
                default() {
                    return {}
                }
            },
            url: {
                type: String,
                required: false,
                default: ''
            },
            design: {
                type: String,
                required: false,
                default: 'md success'
            },
        },

		data() {
			return {
				hasLaunch: true,
                loading: false
			}
		},

        computed: {
			...mapGetters('launchDay', { config: 'getSteps' })
		},

        methods: {
            ...mapActions('launchDay', ['setConfig']),
            /**
             * Event handler que trata o evento de quando o botão de ação é clicado
             * de modo a tratar a ação desejada
             */
            createAdvance() {
                switch(this.method) {
                    case 'create':
                        this.create()
                        break

                    case 'update':
                        this.update()
                        break

                    default:
                        this.nextPage()
                        break
                }
            },
            /**
             * Executa uma requisição para criação com os dados recebidos
             */
            create() {
                if (!this.service){
                    this.$toastr.e('Falha ao avançar! Nenhum service foi registrado para esta página.')
                    return
                }

                this.loading = true
                axios[this.service][this.method](this.url, this.data)
                    .then(async response => {
                        let data = { ...response.data }
                        if (this.url === '') await this.setConfig(data.data)

                        this.$toastr.s(data.msg)
                        this.$emit('input', true, response)
                        this.nextPage()
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                        this.$emit('input', false)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            /**
             * Executa uma requisição para atualização com os dados recebidos
             */
            update() {
                if (!this.service){
                    this.$toastr.e('Falha ao avançar! Nenhum service foi registrado para esta página.')
                    return
                }

                const params = { ...this.data }
                delete params.product
                this.loading = true
                axios[this.service][this.method](this.url, this.data.id, this.data)
                    .then(response => {
                        this.$toastr.s(response.data.msg)
                        this.$emit('input', (true, response))
                        this.nextPage()
                    })
                    .catch(error => {
                        this.$emit('input', false)
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            /**
             * Solicita-se que a página da próxima etapa seja renderizada para continuar
             * o cadastro
             */
            nextPage() {
                if (this.next) this.$root.$emit('altere-point-selected', this.next)
                this.$emit('input', false)
            }
        }
	}
</script>

<style lang="stylus" scoped>
	// @import './styles.styl'
</style>